import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackTutorialsPageView = (userId?: string): void => {
  trackingService.trackEvent(
    'HELP',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route: '/inicio/tutorial',
      placement: '',
      surface: '',
      flow: 'tutoriais',
      step: 'listagem tutoriais',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackTutorialEditLogoClick = (userId?: string): void => {
  trackingService.trackEvent(
    'TUTORIALS',
    PRODUCT_NAME,
    {
      page: 'tutoriais',
      route: '',
      placement: 'main',
      surface: 'card',
      flow: 'tutoriais',
      step: 'editar logo e prescrições',
      element: '',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackTutorialHowToPrescribeClick = (userId?: string): void => {
  trackingService.trackEvent(
    'TUTORIALS',
    PRODUCT_NAME,
    {
      page: 'tutoriais',
      route: '',
      placement: 'main',
      surface: 'card',
      flow: 'tutoriais',
      step: 'usar receita',
      element: '',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackTutorialHowToUseClick = (userId?: string): void => {
  trackingService.trackEvent(
    'TUTORIALS',
    PRODUCT_NAME,
    {
      page: 'tutoriais',
      route: '',
      placement: 'main',
      surface: 'card',
      flow: 'tutoriais',
      step: 'como prescrever',
      element: '',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
